<template>
    <div class="bg-white flex-1 relative overflow-y-auto">
        <loading :status="loading.form"/>
        <form @submit.prevent="saveDocumentation">
            <div class="border-b border-gray-200 py-4 px-5 sm:px-6 lg:px-8">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h1 class="py-0.5 text-2xl font-semibold text-gray-900">Dokumentation erstellen</h1>
                    </div>
                    <div class="mt-4 flex items-center md:mt-0 md:ml-4">
                        <router-link class="btn btn-secondary shadow-sm rounded mr-4" to="/workspace/documentation">
                            Abbrechen
                        </router-link>
                        <button class="btn btn-gray shadow-sm rounded" type="submit">
                            Speichern
                        </button>
                    </div>
                </div>
            </div>

            <div class="px-5 sm:px-6 lg:px-8 py-6">
                <div class="mb-4">
                    <label class="block text-sm font-medium leading-5 text-gray-700" for="title">Titel</label>
                    <input
                        id="title"
                        v-model="documentation.title"
                        class="form-input block w-full mt-1"
                        maxlength="255"
                        required
                    >
                </div>
                <div class="documentation-editor">
                    <input-wysiwyg
                        id="documentation_body_new"
                        v-model="documentation.body"
                        :plugins="{images: true, cannedReply: false, attachment: true, shortCode: false, menuPoint: true, headings: true}"
                        @selectUploadFile="selectUploadFile"
                    >
                        <template v-slot:top>
                            <div :class="{'bg-gray-200': uploadingFileProgress > 0}" class="h-1 w-full">
                                <div :style="{width: uploadingFileProgress + '%'}" class="bg-blue-500 py-0.5"></div>
                            </div>
                        </template>
                    </input-wysiwyg>
                </div>
                <div v-if="documentation.attachments.length > 0" class="mt-4">
                    <div class="flex flex-wrap items-start gap-2">
                        <template v-for="(attachment, index) in documentation.attachments">
                            <attachment :details="attachment" v-on:remove="removeAttachment(index)"/>
                        </template>
                    </div>
                </div>
            </div>
        </form>
        <input ref="fileInput" hidden type="file" @change="uploadFile($event)">
    </div>
</template>

<script>
import {resolveAccessState} from "@/utils/access-state";

export default {
    name: "documentation-new",
    metaInfo() {
        return {
            title: "Dokumentation erstellen"
        }
    },
    data() {
        return {
            loading: {
                form: false,
                file: false,
            },
            uploadingFileProgress: 0,
            documentation: {
                title: '',
                body: '',
                attachments: [],
            }
        };
    },
    computed: {
        accessState() {
            return resolveAccessState(this.$store);
        },
        canCreateDocumentation() {
            return this.accessState.isAdmin || this.accessState.isEmployeeLike;
        },
    },
    mounted() {
        if (!this.canCreateDocumentation) {
            this.$router.replace('/workspace/documentation');
        }
    },
    methods: {
        saveDocumentation() {
            if (!this.canCreateDocumentation) {
                this.$router.replace('/workspace/documentation');
                return;
            }
            const self = this;
            self.loading.form = true;
            axios.post('api/workspace/documentations', self.documentation).then(function (response) {
                self.loading.form = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/workspace/documentation/' + response.data.documentation.id + '/manage');
            }).catch(function () {
                self.loading.form = false;
            });
        },
        selectUploadFile() {
            if (!this.loading.file) {
                this.$refs.fileInput.click();
            } else {
                this.$notify({
                    title: this.$i18n.t('Error').toString(),
                    text: this.$i18n.t('A file is being uploaded').toString(),
                    type: 'warning'
                });
            }
        },
        uploadFile(e) {
            const self = this;
            const formData = new FormData();
            self.loading.file = true;
            formData.append('file', e.target.files[0]);
            axios.post(
                'api/workspace/documentations/attachments',
                formData,
                {
                    headers: {'Content-Type': 'multipart/form-data'},
                    onUploadProgress: function (progressEvent) {
                        self.uploadingFileProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    }.bind(this)
                }
            ).then(function (response) {
                self.loading.file = false;
                self.uploadingFileProgress = 0;
                self.$refs.fileInput.value = null;
                self.documentation.attachments.push(response.data);
            }).catch(function () {
                self.loading.file = false;
                self.uploadingFileProgress = 0;
                self.$refs.fileInput.value = null;
            });
        },
        removeAttachment(attachment) {
            this.documentation.attachments.splice(attachment, 1);
        },
    }
}
</script>

<style lang="scss">
.documentation-editor .tox.tox-tinymce {
    min-height: 360px;
}
</style>
